import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useSessionStorage } from 'usehooks-ts';
import { OEMType as EOEMType } from '../../types.ts';
import Banner from '../Banner/Banner.tsx';
import Body from '../Body/Body.tsx';
import Button from '../Button/Button.tsx';
import ButtonGroup from '../ButtonGroup/ButtonGroup.tsx';
import messages from './SignOutLanding.messages.ts';
import './SignOutLanding.scss';
import { buildEntraLoginUrl } from '../Login/buildEntraLoginUrl.ts';

export type LogoutProps = {
  oem_type?: EOEMType;
  portalType?: string;
};

const SignOutLanding = ({ oem_type = EOEMType.Brunswick, portalType }: LogoutProps) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const [mfaConfigError, setMfaConfigError] = useState(false);
  const [OEMType, setOEMType] = useSessionStorage<EOEMType>('OEMType', oem_type);

  useEffect(() => {
    // left in intentionally for use without erroring
    console.info('Current oem_type', OEMType);
    setOEMType(oem_type);
  }, [oem_type]);

  const redirectToEntra = (mode: 'STAGING' | 'PRODUCTION' | 'DEV') => {
    if (portalType !== 'dealer' && portalType !== 'admin') {
      return;
    }

    const redirectUrl = buildEntraLoginUrl(portalType, mode);

    if (!redirectUrl) {
      setMfaConfigError(true);
      return;
    }

    setMfaConfigError(false);
    window.location.assign(redirectUrl);
  };

  return (
    <>
      <Banner OEMType={oem_type}>{formatMessage(messages.title)}</Banner>
      <Body>
        <h3 className="subHeading">{formatMessage(messages.subMessage)}</h3>
        {mfaConfigError && <p className="error">{formatMessage(messages.MFAConfigError)}</p>}
        <ButtonGroup>
          <Button
            className="redirect-button"
            type="button"
            variant="secondary"
            onClick={() => {
              const isMfaLoginEnabled = import.meta.env.VITE_MFA_LOGIN_ENABLED === 'true';
              if (import.meta.env.MODE == 'PRODUCTION' && isMfaLoginEnabled) {
                redirectToEntra('PRODUCTION');
              } else if (import.meta.env.MODE == 'STAGING' && isMfaLoginEnabled) {
                redirectToEntra('STAGING');
              } else if (
                (import.meta.env.MODE == 'DEV' || import.meta.env.MODE == 'development') &&
                isMfaLoginEnabled
              ) {
                redirectToEntra('DEV');
              } else if (!isMfaLoginEnabled) {
                navigate('/login');
              } else {
                navigate('*');
              }
            }}>
            {formatMessage(messages.MFAButton)}
          </Button>
        </ButtonGroup>
      </Body>
    </>
  );
};

export default SignOutLanding;
